
// Components
import Detail from "pages/Sales/Transaction/Invoice/components/Detail"

export function DetailInvoice(): JSX.Element {
  // Hooks
  return (
    <Detail isDetailShop={true}/>
  )
}